import React from "react";
import "./Footer.scss";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__socials">
          <a href="#reseaux" className="footer__social" aria-label="Facebook">
            <FacebookIcon />
          </a>
          <a href="#reseaux" className="footer__social" aria-label="Instagram">
            <InstagramIcon />
          </a>
          <a href="#reseaux" className="footer__social" aria-label="Twitter">
            <TwitterIcon />
          </a>
          <a href="#reseaux" className="footer__social" aria-label="YouTube">
            <YouTubeIcon />
          </a>
        </div>

        <div className="footer__grid">
          <a href="#faq">FAQ</a>
          <a href="#media">Centre d&apos;aide</a>
          <a href="#confidentialite">Confidentialite</a>
          <a href="#conditions">Conditions d&apos;utilisation</a>
          <a href="#catalogue">Catalogue</a>
          <a href="#support">Support</a>
          <a href="#entreprise">Informations entreprise</a>
          <a href="#contact">Nous contacter</a>
        </div>

        <p className="footer__copy">Streamflix by MobingKonnect</p>
      </div>
    </footer>
  );
}

export default Footer;
